// Attributes
export const SET_ATTRIBUTES = "SET_ATTRIBUTES";

// Companies
export const INITIATE_EXPAND_SECTION = "INITIATE_EXPAND_SECTION";
export const EXPAND_ITEM = "EXPAND_ITEM";

// ZoneTree
export const INITIATE_EXPAND_ZONE = "INITIATE_EXPAND_ZONE";
export const TOGGLE_ZONE = "TOGGLE_ZONE";
export const EXPAND_ZONE = "EXPAND_ZONE";
export const CONTRACT_ZONE = "CONTRACT_ZONE";

// Global
export const SET_BREADCRUMB = "SET_BREADCRUMB";
export const SET_KEEP_ME_LOGGED_IN = "SET_KEEP_ME_LOGGED_IN";
export const SET_ERROR = "SET_ERROR";
export const ENABLE_POWER_USER_MODE = "ENABLE_POWER_USER_MODE";
export const SET_VIEW_UNMATCHED = "SET_VIEW_UNMATCHED";

// Events
export const EVENTS_REQUEST = "EVENTS_REQUEST";
export const RECEIVE_EVENT_GROUPS = "RECEIVE_EVENT_GROUPS";
export const RECEIVE_CHILD_EVENT_GROUPS = "RECEIVE_CHILD_EVENT_GROUPS";
export const RECEIVE_EVENTS = "RECEIVE_EVENTS ";
export const EVENTS_FAILED = "EVENTS_FAILED ";

// Live Events
export const ADD_DAC_DETAILS = "ADD_DAC_DETAILS";
export const ADD_EVENT = "ADD_EVENT";
export const CLEAR_ZONE_EVENTS = "CLEAR_ZONE_EVENTS";
export const INITIATE = "INITIATE";
export const INITIATE_ZONE = "INITIATE_ZONE";
export const OPEN_CARD = "OPEN_CARD";
export const SET_OPEN = "SET_OPEN";
export const SET_TIMEOUT = "SET_TIMEOUT";
export const UPDATE_EVENTS = "UPDATE_EVENTS";

// Lov
export const SET_LOV = "SET_LOV";

// Policies
export const GET_POLICIES = "GET_POLICIES";
export const GET_PUBLISHERS = "GET_PUBLISHERS";
export const GET_ACCEPTANCES = "GET_ACCEPTANCES";
export const SET_STATUS = "SET_STATUS";

// Profiles
export const REQUEST_PROFILES = "REQUEST_PROFILES";
export const RECEIVE_PROFILES = "RECEIVE_PROFILES";
export const FAILED_FETCH_PROFILES = "FAILED_FETCH_PROFILES";
export const SET_FILTERED_PROFILES = "SET_FILTERED_PROFILES";
export const SET_NOTE_FILTER = "SET_NOTE_FILTER";
export const SET_FILTERS = "SET_FILTERS";
export const SET_SEARCHED_PROFILES = "SET_SEARCHED_PROFILES";
export const CLEAN_SEARCHED_PROFILES = "CLEAN_SEARCHED_PROFILES";
export const RECEIVE_NEW_PROFILES = "RECEIVE_NEW_PROFILES";
export const SET_PROFILES_LOV = "SET_PROFILES_LOV";

// Scheduler
export const SET_SCHEDULER_FILTERS = "SET_SCHEDULER_FILTERS";

// Site Entrance Exit
export const REQUEST_COMPANIES = "REQUEST_COMPANIES";
export const RECEIVE_COMPANIES = "RECEIVE_COMPANIES";
export const FAILED_COMPANIES = "FAILED_COMPANIES";

export const INITIATE_SITE_ZONE = "INITIATE_SITE_ZONE";
export const REPLACE_SITE_ZONE = "REPLACE_SITE_ZONE";
export const REMOVE_SITE_ZONE = "REMOVE_SITE_ZONE";
export const REMOVE_ALL_SITE_ZONES = "REMOVE_ALL_SITE_ZONES";

export const SELECT_SITE = "SET_SITE";
export const RESET_SITE = "RESET_SITE";
export const RESET_TABS = "RESET_TABS";
export const SELECT_TAB = "SELECT_TAB";
export const SELECT_SECTION = "SELECT_SECTION";
export const ADD_TAB = "ADD_TAB";
export const SAVE_TAB_DATA = "SAVE_TAB_DATA";
export const REMOVE_TAB = "REMOVE_TAB";
export const CHANGE_TAB_ZONE = "CHANGE_TAB_ZONE";
export const REQUEST_LOGS_TAB = "REQUEST_LOGS_TAB";
export const RECEIVE_LOGS_TAB = "RECEIVE_LOGS_TAB";
export const RECEIVE_LOGS_TAB_OLD = "RECEIVE_LOGS_TAB_OLD";
export const FAILED_LOGS_TAB = "FAILED_LOGS_TAB";
export const SORT_LOGS_TAB = "SORT_LOGS_TAB";
export const FILTER_LOGS_TAB = "FILTER_LOGS_TAB";
export const ADD_LATEST_LOG_TAB = "ADD_LATEST_LOG_TAB";
export const RESET_TAB_LOGS = "RESET_TAB_LOGS";
export const UPDATE_LOG_TAB = "UPDATE_LOG_TAB";
export const UPDATE_LOG_DATA = "UPDATE_LOG_DATA";
export const UPDATE_LOG_SELECTED_RAILCAR_ID = "UPDATE_LOG_SELECTED_RAILCAR_ID";
export const UPDATE_LOG_SELECTED_UNIT_ID = "UPDATE_LOG_SELECTED_UNIT_ID";
export const SET_LOGS_PAGE = "SET_LOGS_PAGE";
export const SET_LOGS_ROWS_PER_PAGE = "SET_LOGS_ROWS_PER_PAGE";
export const SET_DETECTION = "SET_DETECTION";
export const SET_MAIN_NOTES = "SET_MAIN_NOTES";
export const SET_COLLAPSED = "SET_COLLAPSED";
export const UPDATE_FILTERED_LOGS = "UPDATE_FILTERED_LOGS";
export const UPDATE_FILTERS = "UPDATE_FILTERS";

export const SET_INITIALIZED = "SET_INITIALIZED";

export const ADD_TAB_HISTORY = "ADD_TAB_HISTORY";
export const REMOVE_TAB_HISTORY = "REMOVE_TAB_HISTORY";

export const SET_FIELD_VALUE = "SET_FIELD_VALUE";
export const CLEAR_STORE = "CLEAR_STORE";

// User
export const SET_USER = "SET_USER";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const USER_LOGOUT = "USER_LOGOUT";

// Users
export const SAVE_USER = "SAVE_USER";

//dynamic splash
// export const DYNAMIC_THEME_SPLASH = "DYNAMIC_THEME_SPLASH";
// export const DYNAMIC_THEME_THUMBNAIL = "DYNAMIC_THEME_THUMBNAIL"
export const DYNAMIC_THEME_INFO="DYNAMIC_THEME_INFO";